module.exports = __webpack_public_path__ + "static/media/scatter_chart.c71f416a.svg";